import { socketRoomName } from "config/socketConfig";
import { ExpiredTime, price_stock_analysis } from "constants/configLocalStorage";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPriceStockAnalysis } from "store/actionReducers/StocksAnalysisStore";
import useChart from "./useChart";

export default function useSocketCall(socket: any) {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>(null)
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const symbol = StocksAnalysisStore?.inputSearch
  const dataPriceOld = StocksAnalysisStore?.priceStockAnalysis

  useEffect(() => {
    socket.on(socketRoomName.instrument, (message: any) => {
      // console.log(message, 'message');
      setData(message)
    });
  }, [])

  const fetchSubscribeStock = useCallback((stock: any) => {
    if (stock) {
      socket.emit('get', {
        url: '/client/subscribe',
        method: 'get',
        headers: {},
        data: {
          op: 'subscribe',
          args: [`i:${stock}`],
        }
      }, (response: any) => {
        if (response.statusCode === 200) {
          // console.log(response, 'UnSubscribed to topics');
        } else {
          // console.log(response, 'Fail to subscribe to topics');
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    if (data?.d) {
      fillDataCall(data)
    }
  }, [data])

  const fillDataCall = useCallback((itemStock: any) => {
    if (itemStock?.d && itemStock?.d?.length > 0) {
      const value: any = itemStock?.d?.[0];

      if (value?.SB === symbol) {
        if (dataPriceOld && Object.values(dataPriceOld).length > 0 && dataPriceOld?.[symbol] && symbol) {
          const listPriceStock = { ...dataPriceOld }
          const vStock = { ...listPriceStock?.[symbol] }

          if (value?.t) { vStock.time = parseInt((value?.t / 1000).toString()) }
          if (value?.TT) { vStock.volumn = value?.TT }
          if (value?.OP) { vStock.priceOpen = value?.OP / 1000 }
          if (value?.CP) { vStock.priceClose = value?.CP / 1000 }
          listPriceStock[symbol] = vStock;
          const time = moment().add(ExpiredTime, 'minutes').valueOf()
          localStorage.setItem(price_stock_analysis, JSON.stringify({ time: time, data: listPriceStock }))

          // return listPriceStock;
          dispatch(setPriceStockAnalysis(listPriceStock))
        }
      }
    }
  }, [symbol, dataPriceOld])

  return { fetchSubscribeStock, fillDataCall }
}